<template>
<div class="container">
    <nav class="breadcrumb" aria-label="breadcrumb">
        <ol class="breadcrumb-list">
            <!-- 首页 -->
            <li class="breadcrumb-item">
                <router-link to="/"><i class="fas fa-home"></i> 首页</router-link>
            </li>
            
            <!-- 一级分类 -->
            <li class="breadcrumb-item">
                <router-link to="/blog">Blog</router-link>
            </li>
            
            <!-- 当前页面（不加链接，添加 is-active 类） -->
            <li class="breadcrumb-item is-active">
                <span>{{ title }}</span>
            </li>
        </ol>
    </nav>
    <h1>{{ title }}</h1>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/rollerbanner.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>RollerCoin 是为让你玩游戏和建设数据中心而制作的，同时你可以赚取你的第一批真实加密货币！但是，请不要把在 RollerCoin 挖矿作为你的主要收入来源。</p>
    <p>RollerCoin 是一款挖矿游戏，它的目的是让你在游戏中获得乐趣，并以真实的加密货币获得奖励。</p> 

    <h2>成就系统</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/achievements.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>成就奖励：作为新手，最重要的是看成就奖励，这样可以明白当前的定位和任务。有了成就的奖励就可以购买机架和矿机，购买零件，提升算力。</p>
    <p>算力：由矿机算力、游戏算力、加成算力、奖励算力、矿机架子加成算力组成。矿机的算力矿机架子加成算力是永久的算力，游戏获得的算力和奖励算力是临时的，游戏算力过期时间是24小时，奖励算力则会在获得的时候说明。</p>
    
    <h2>游戏</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/game.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>游戏可以获得算力奖励、代币奖励、零件奖励，电池奖励。</p>
    <p>每日任务中有根据完成游戏的次数，获得相应奖励。</p>

    <h2>钱包</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/wallet.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>可以挖取主流的币种，包括比特币、以太坊、币安币、solana、XRP、trx、pol、usdt、莱特币</p>
    <p>还能挖取平台的代币和平台积分，平台代币为Roller币，以下称为R币。根据算力等级可以解锁币种的挖取。</p>
    
    <h2>房间</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/rollerhome.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>新用户免费获得一个初始房间，可以放置12个矿机架子。矿机需要电池驱动（一个电池可烧四天）。剩下0-12小时时，可以免费将电池加到一天（24小时）。</p>
    <p>房间的主要作用就是放置矿机。矿机架子分为两种，有三层架子和四层架子。这里推荐四层架子（从成就系统中获得R币奖励之后可以去商店购买）</p>

    <h2>制作矿机</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/grafting.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>制作矿机需要零件和R币，零件或者矿机。如果满足制作条件可以优先制作。每个矿机的制作条件都不同（R币消耗和零件数量）。</p>

    <h2>合并矿机</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/merge.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>矿机是分等级的，一共分为6级，需要两个低等级才能合并一个高等级。对应也需要相应等级的零件。每个矿机的合并条件都不同（R币消耗和零件数量）。</p>

    <h2>玩家市场</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/market.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>玩家市场是玩家交易矿机、机架、零件、电池以及其他资源的地方。</p>
    <p>玩家可以在这里购买和卖出自己多余或者需要卖出的资源。价格根据市场需求变动。</p>
    
    <h2>用户商店</h2>
    <div style="height:25px" aria-hidden="true"></div>
    <img src="../../assets/img/store.png" alt="">
    <div style="height:25px" aria-hidden="true"></div>
    <p>用户商店是官方定价和优惠的地方，可以购买优惠价格的矿机，可以购买官方上架的矿机，可以购买矿机架子。这些价格都是固定的。</p>

    <div style="height:25px" aria-hidden="true"></div>
    <div style="height:25px" aria-hidden="true"></div>
    <div style="height:25px" aria-hidden="true"></div>
    <p>文本选择👇</p>
    <p style="text-decoration: underline;color: #2f3045; font-size: 1.2rem;">达到了官方提取的数量，不知道如何变现的，可以通过网站上联系页面的方式联系。卖给我，我会用微信和支付宝转账。</p>
    <div style="height:25px" aria-hidden="true"></div>
    <h2>如果想加入RollerCoin，点击下面图片加入，感谢您的认可。👇👇👇</h2>
    <!--Start rollercoin.com code-->
    <a href="https://rollercoin.com/?r=lk0qxc8o">
        <img src="https://static.rollercoin.com/static/img/ref/gen2/w970h90.gif" alt="970h90"/>
    </a>
    <!--End rollercoin.com code-->
					
  </div>
</template>

<script>
export default{
    name: 'RollerCoin',
    data(){
        // data 必须是一个函数，以避免多个实例间的数据共享
        return {
            title: 'rollercoin 新手攻略',
            showMessage: true,
        }
    },
    methods: {
        // 定义事件处理函数
        updateTitle(newTitle) {
          this.title = newTitle;
        },
        
    },
    mounted() {
        // 组件挂载到 DOM 后执行
        console.log('组件已挂载');
        
    },
    beforeDestroy() {
        
    }
}
</script>

<style scoped>

.container {
  padding: 20px;
  background-color: #2f3045;
  color: #fff;
  max-width: 1200px;
    margin: 20px auto;
    width: 100%;
    box-sizing: border-box;
}

h2{
    color: #03e1e4;
    margin: 30px 0px;
    line-height: 1;
}
/* 面包屑容器 */
.breadcrumb {
    /* 使用 Flexbox 排列元素 */
    display: flex;
    /* 内边距 */
    padding: 15px 0px;
    margin: 0 auto;
}
/* 列表样式：去除默认的圆点 */
.breadcrumb-list {
    display: flex;
    list-style: none;
    /* 确保列表项之间有间隔 */
    margin: 0;
    padding: 0;
    flex-wrap: wrap; /* 允许换行，防止长路径溢出 */
}

/* 每个层级的样式 */
.breadcrumb-item {
    color: #fff;
    font-size: 14px;
}

/* 链接样式 */
.breadcrumb-item a {
    color: #fff;
    text-decoration: none;
    transition: color 0.2s ease;
}

.breadcrumb-item a:hover {
    color: #fff;
    text-decoration: underline;
}

/* 当前页面（通常是最后一个）的样式 */
.breadcrumb-item.is-active {
    color: #07e1e4;
    font-weight: 500;
}

/* 分隔符：使用伪元素在每个项目后面添加斜杠 */
.breadcrumb-list .breadcrumb-item:not(:last-child)::after {
    content: "/";
    margin: 0 8px;
    color: #fff;
}

/* 隐藏最后一个项目的分隔符 */
.breadcrumb-item.is-active::after {
    display: none;
}
</style>